import apiService from "./apiService";

export const getAddressValues = () =>
  apiService.get<{
    us_states: { id: string; name: string }[];
    countries: { id: string; name: string }[];
  }>(`/customer_api/v2/address_values`);
